import { useEffect, useMemo } from 'react'
import useAxios from 'axios-hooks'
import { UNITED_STATES } from 'utils/constants'
import { concat } from 'lodash'
import { otherStateList } from 'services/options-lists'
import { useProgramContext } from 'providers/programProvider'
import { actions } from 'providers/programProvider/location/actions'

function sanitizeStateName(stateName) {
  return stateName?.replace(/(Canada|Mexico)(\s-\s)/, '') || stateName
}

export const useStateCodes = () => {
  const [state, dispatch] = useProgramContext()

  const [{ data, loading, error }] = useAxios(
    { url: 'stateCodes' },
    { manual: !!state?.states },
  )

  useEffect(() => {
    if (data) {
      const states = concat(data.filter(({ iso2 }) => iso2 === UNITED_STATES), otherStateList)
        .reduce((acc, { id, name, isoCode, countyCodes, countryCode, label }) => {
          acc.push({
            value: id || isoCode,
            name: name || label,
            label: sanitizeStateName(name || label),
            isoCode,
            countryCode: countryCode || UNITED_STATES,
            counties: countyCodes?.reduce((acc, { id, name, code }) => {
              acc.push({
                value: id,
                label: name,
                code,
              })
              return acc
            }, []),
          })
          return acc
        }, [])

      dispatch(actions.setStates(states))
    }
  }, [data])

  return useMemo(
    () => ({
      loading,
      stateList: state?.states,
      error,
    }),
    [error, loading, state?.states],
  )
}
